import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataMember(params) {
	return client.get("api/ecommerce/member/data", {
		params: params,
	});
}

function getDataNewMember(params) {
	return client.get("api/ecommerce/member/data-new-member", {
		params: params,
	});
}

function exportMember(params) {
	return client.get("api/ecommerce/member/export", {
		params: params,
	});
}

function exportNewMember(params) {
	return client.get("api/ecommerce/member/export-new-member", {
		params: params,
	});
}

function resendRegistration(params) {
	return client.post("api/ecommerce/member/resend-registration", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateMember(params) {
	return client.post("api/ecommerce/member/update-member", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataMember,
	getDataNewMember,
	exportMember,
	exportNewMember,
	resendRegistration,
	updateMember,
}